import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
export class TraitRegistrySystemKeyboard extends TraitRegistryCategory {
    label = 'Keyboard';
    constructor(parent) {
        super(parent);
        super.init();
    }
    keyboardKey = () => new TraitTypeSelect( /*{
      label: 'Taste',
      select: [['r'], [' ', 'Space'], ['Control'], ['Alt'], ['Enter']]
    }*/);
}
